import PropTypes from "prop-types";
import React, { Fragment, useState, useEffect } from "react";
import MetaTags from "react-meta-tags";
import { useToasts } from "react-toast-notifications";
import * as Yup from "yup";
import { Input, Form, Spin } from "antd";
import { connect } from "react-redux";
import backgroundImage from "../../.././src/assets/images/stepper-bgimage.png";
import { ReactComponent as KhubLogo } from "../../.././src/assets/images/logo.svg";
import { useHistory } from "react-router-dom";
import { customerRenewPassword, customerResetPassword } from "../../redux/actions/loginActions";
import { Formik, Field, ErrorMessage } from "formik";
import { PASSWORD_REG_EXP } from "../constant/Constants";

const ConfirmNewPassword = ({ location, settings }) => {
  const [loading, setLoading] = useState(false);
  const history = useHistory();
  const { addToast } = useToasts();

  return (
    <Fragment>
      <MetaTags>
        <title>{settings?.ecom_title} | Login</title>
        <meta
          name="description"
          content={`Login page of ${settings?.ecom_title} eCommerce template.`}
        />
      </MetaTags>
      <div className="login-page-container">
        <div
          className="login-wrapper"
          style={{
            backgroundImage: `url(${backgroundImage})`,
          }}
        >
          <div className="loginpage-logo">
            <span className="page-route" onClick={() => history.push(`/home`)}>
              <KhubLogo style={{ maxWidth: "100%", height: "auto" }} />
            </span>
          </div>
        </div>
        <div className="side-content">
          <div className="forgot-password-container">
            <h1>Set A New Password?</h1>
            <Formik
              initialValues={{
                email: JSON.parse(localStorage.getItem('resetPasswordOtp'))?.email,
                password: "",
                confirm_password: "",
              }}
              validationSchema={() =>
                Yup.lazy((values) => {
                  return Yup.object().shape({
                    password: Yup.string()
                      .nullable()
                      .matches(
                        /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~"]).{8,300}$/,
                        "At least 8 characters with 1 uppercase letter, 1 lowercase letter, 1 special character, and 1 number required"
                      )
                      .required("Password is required"),
                    confirm_password: Yup.string()
                      .nullable()
                      .required("Password confirmation is required")
                      .test("passwords-match", "Passwords must match", function (value) {
                        return value === this.parent.password;
                      }),
                  });
                })
              }
              onSubmit={async (values) => {
                try {
                  const res = await customerRenewPassword(values, JSON.parse(localStorage.getItem('resetPasswordOtp'))?.tocken);
                  addToast(res.data.message, {
                    appearance: "success",
                    autoDismiss: true,
                    PlacementType: "top-right",
                    placement: "top-right",
                  });
                  history.push(`/login`);
                } catch (err) {
                  err.response.data.errors.map((error) =>
                    addToast(error, {
                      appearance: "error",
                      autoDismiss: true,
                      PlacementType: "top-right",
                      placement: "top-right",
                    })
                  );
                }
              }}
            >
              {({ errors, handleSubmit }) => (
                <Spin spinning={loading}>
                  <Form onSubmit={handleSubmit}>
                    <Form.Item className="pwd-field">
                      <label className="login-field-labels">New Password*</label>
                      <Field 
                        name="password"
                        as={Input.Password} 
                        placeholder="Enter Password" 
                    />
                      <ErrorMessage
                        name="password"
                        component="div"
                        className="text-danger"
                      />
                    </Form.Item>
                    <Form.Item className="pwd-field">
                      <label className="login-field-labels">Confirm Password*</label>
                      <Field name="confirm_password" as={Input.Password}  placeholder="Enter Confirm Password" />
                      <ErrorMessage
                        name="confirm_password"
                        component="div"
                        className="text-danger"
                      />
                    </Form.Item>
                    <Form.Item>
                      <button
                        className="login-btn-forgot-password"
                        type="button"
                        onClick={handleSubmit}
                      >
                        Verify
                      </button>
                    </Form.Item>
                  </Form>
                </Spin>
              )}
            </Formik>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

ConfirmNewPassword.propTypes = {
  location: PropTypes.object,
};

const mapStateToProps = (state) => {
  return {
    settings: state.settingData.ecom.basic,
  };
};

export default connect(mapStateToProps)(ConfirmNewPassword);